import store from '@/store'
import { getCertificateLevel } from '@/store/modules/common/types'

// import token from '@/utils/token'
import global from '@/utils/global'
const needActiveCallBack = (router) => {
  router.beforeEach(async (to, from, next) => {
    if (store.getters.isApp) {
      // 在客户端的逻辑
      to.meta.navHide = store.getters.isApp // 隐藏title
    } else {
      // 不是在客户端打开
      // store.commit('change_noAppVisible', true)
    }
    // 登录逻辑判断
    if (to.meta.noLogin) {
      return next()
    } else if (!to.meta.noLogin && !global.getCookie() && !store.getters.isApp) { // 需要登录、没有登录、且不是在客户端内 可以跳转到H5登录页面
      global.setLoginErrorHandle(500102, 'invalid token') // 安卓客户端注册快递时，没有种上token和isApp 前端自己处理下，后期删除
      // return next()
      return next({ name: 'Register' })
    }

    if (!(Object.keys(store.state.common.certificateLevel).length)) {
      await store.dispatch(getCertificateLevel)
    }
    // await store.dispatch(getAuth)

    if (to.meta.needActive) { // 是否需要激活才能访问 KYC
      if (store.getters.isActive) { // 跳转的页面是否激活 true：已激活 false: 未激活
        const { signCardFlag, accountStatus, userStatus } = store.getters // 高低实名 是否绑定卡 账户状态
        if (userStatus !== 1 && (to.name === 'Transfer' || to.name === 'Withdraw' || to.name === 'TopUpAdmin')) { // 用户状态异常时候 userStatus = 1 代表用户状态正常
          store.commit('change_errorVisible', true)
          return
        }
        if (accountStatus && (to.name === 'Transfer' || to.name === 'Withdraw' || to.name === 'TopUpAdmin')) { // 账户状态 0:正常 1：冻结 2：注销
          store.commit('change_accountVisible', true)
          return
        }
        if (!signCardFlag && to.meta.cardFlag) { // signCardFlag 为 false 表示没有绑卡 cardFlag为true需要绑卡
          store.commit('change_addCardVisible', true)
          return
        }
        // if (to.name === 'Transfer') { // 进入转账页面
        //   if (verifiedStatus === 2) { // 目前低级别用户 转账的话需要是高级别用户 verifiedStatus === 2为低级用户
        //     store.commit('change_kycVisible', true)
        //     return
        //   }
        // }
      } else { // 未激活
        store.commit('change_activeVisible', true)
        return
      }
    } else if (to.name === 'Home') { // 只有在home页面展示这个弹窗前提是没有激活和不是等待人工审核
      store.commit('change_agreementVisible', true)
    }
    next()
  })
}
export default needActiveCallBack
